import { combineReducers } from 'redux';
import { userRolesReducer } from './UserRoles/reducer';

const dynamicReducer = combineReducers({
  userRolesReducer: userRolesReducer, // dynamic blacklist
});

export default dynamicReducer;